import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";import _createClass from "@babel/runtime-corejs3/helpers/createClass";import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";import _inherits from "@babel/runtime-corejs3/helpers/inherits";import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = _getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf(this).constructor;result = _Reflect$construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !_Reflect$construct) return false;if (_Reflect$construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}import { computed, makeObservable, observable } from 'mobx';
import { BasicFormControl } from "./BasicFormControl";
import { VALIDATIONS_RULES } from "./validationsMapping";






export var FormControl = /*#__PURE__*/function (_BasicFormControl) {_inherits(FormControl, _BasicFormControl);var _super = _createSuper(FormControl);




































  function FormControl(initialValue, params) {var _params$validations;var _this;_classCallCheck(this, FormControl);
    _this = _super.call(this, initialValue, params);_defineProperty(_assertThisInitialized(_this), "validations", []);_defineProperty(_assertThisInitialized(_this), "dependencyFields", []);
    _this.validations =
    (params === null || params === void 0 ? void 0 : (_params$validations = params.validations) === null || _params$validations === void 0 ? void 0 : _mapInstanceProperty(_params$validations).call(_params$validations, function (validationName) {return VALIDATIONS_RULES[validationName];})) || [];
    if (params !== null && params !== void 0 && params.dependencyFields) {
      _this.dependencyFields = params.dependencyFields;
    }

    makeObservable(_assertThisInitialized(_this), {
      validations: observable,
      unpassedValidationMsg: computed,
      dependencyFields: observable
    });return _this;
  }_createClass(FormControl, [{ key: "unpassedValidationMsg", get: // The list of the validations that are went over in the unpassedValidationsMsg getter.
    // The fields which value affects whether this FormControl is optional or not.
    // Returns the validation status of this FormControl value.
    function get() {var _this2 = this;if (this.skipValidation()) {return null;} // If secondLevelValidation happened and has an error message, show it
      if (this.secondLevelValidationMessage) {return this.secondLevelValidationMessage;} // Runs basic validation if no validations added.
      if (this.validations.length < 1) {return this.isBasicValidationPassed() ? null : 'Valid value required';} // Returns the first unpassed validation of the validations array.
      var validationMessage = null;this.validations.forEach(function (validationRule) {if (validationMessage !== null) {return;} // Trim input string if trim set to true
        if (_trimInstanceProperty(_this2) && typeof _this2.value === 'string') {var _context;validationMessage = validationRule.check(_trimInstanceProperty(_context = String(_this2.value)).call(_context)) ? null : validationRule.msg;} else {validationMessage = validationRule.check(_this2.value) ? null : validationRule.msg;}});return validationMessage;} }]);return FormControl;}(BasicFormControl);
//# sourceMappingURL=FormControl.js.map